import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const categoryApi = createApi({
    reducerPath: 'categoryApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_ROUTE}`,
        prepareHeaders: (headers, { getState }) => {
            const token = getState()?.posData?.token;
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getCategories: builder.query({
            query: () => ({
                url: `/pos/categories?perPage=all`, // update URL as per your API endpoint
                method: 'GET',
            }),
            // Uncomment and update as needed:
            // transformResponse: (resp) => transformResponseHandler(resp),
            providesTags: ['Categories'],
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        addCategories: builder.mutation({
            query: (body) => ({
                url:'/pos/categories',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Categories'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        updateCategories: builder.mutation({
            query: ({id, ...body}) => ({
                url:`/pos/categories/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Categories'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        deleteCategory: builder.mutation({
            query: (id) => ({
                url: `/pos/categories/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Categories'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        changeStatus:builder.mutation({
            query: ({id, body}) => ({
                url:`/pos/categories/change-status/${id}`,
                method: 'PUT',
                body: {status: body},
            }),
            invalidatesTags: ['Categories'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        uploadImage: builder.mutation({
            query: (body) => ({
                url: '/upload',
                method: 'POST',
                body,
            }),
            transformErrorResponse: (error) => transformResponseHandler(error),
        }),
    }),
});

export const { useGetCategoriesQuery, useAddCategoriesMutation, useUpdateCategoriesMutation, useDeleteCategoryMutation, useChangeStatusMutation, useUploadImageMutation } = categoryApi;
